import { render } from "./B2bPageDocumentacion.vue?vue&type=template&id=358999cf&scoped=true&lang=pug"
import script from "./B2bPageDocumentacion.vue?vue&type=script&lang=js"
export * from "./B2bPageDocumentacion.vue?vue&type=script&lang=js"

import "./B2bPageDocumentacion.vue?vue&type=style&index=0&id=358999cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358999cf"]])

export default __exports__